import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import Slide from "@material-ui/core/Slide";
import newAddressbook from "../../../../../../assets/icon-ic-pin-dark.svg";
import AddressItem from "./addressItem";
import styles from './style.module.css';

import {
  SetAddressBookSearchRegex,
  SetopenAddressBookInNewOrder,
} from "../../../../../../Redux/actions/actionNames";
import { Get_Addressbook_list_Api } from "../../../../../../helper/api";
import { BottomScrollListener } from "react-bottom-scroll-listener";
import { CLOSE, IC_SEARCH, newsearch } from "../../../../../../assets";
import Button from "../../../../../../design-system/lib/Button";
import Typography from "../../../../../../design-system/lib/Typography";
import Input from "../../../../../../design-system/lib/Input";

var _ = require("lodash");

class AddressbookEditOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddressbook: false,
      openNewAddress: false,
      openEditAddress: false,
    };
    this.ps = null;
    this.loadMore = this.loadMore.bind(this);
  }

  loadMore = () => {
    Get_Addressbook_list_Api(
      this.props.dispatch,
      {
        customerId: this.props.customerId || this.props.BusinessId,
        page: this.props.page,
        perpage: 10,
        searchRegex: this.props.searchRegex,
      },
      (call) => { }
    );
  };

  componentDidMount() {

    document.addEventListener('closeSliders', () => {
      //
 
      this.closeAddressbook()
 
       //
     })
    // try {
    //   const container = document.getElementById("AddressBookListOrder");
    //   this.ps = new PerfectScrollbar(container);
    //   container.addEventListener("ps-y-reach-end", () => {
    //     this.loadMore();
    //   });
    // } catch (error) {}
  }

  componentWillReceiveProps(nextProps) {
    // setTimeout(() => {
    //   if (nextProps.openAddressBook && this.ps == null && this.props.list.length > 0) {
    //     try {
    //       const container = document.getElementById("AddressBookListOrder");
    //       this.ps = new PerfectScrollbar(container);
    //       container.addEventListener("ps-y-reach-end", () => {
    //         this.loadMore();
    //       });
    //     } catch (error) {}
    //   }
    // }, 300);

   //   document.removeEventListener('closeSliders');
  }

  handleOpenNewAddress = () => {
    this.setState({
      openNewAddress: !this.state.openNewAddress,
    });
  };

  handleEditAddress = () => {
    this.setState({
      openEditAddress: !this.state.openEditAddress,
    });
  };

  openAddressbook = () => {
    this.setState({
      openAddressbook: true,
    });
  };

  closeAddressbook = () => {
    this.props.dispatch(SetopenAddressBookInNewOrder(false, "", null, ""));
  };

  AddressbookSearchbar = (e) => {
    this.props.dispatch(SetAddressBookSearchRegex(e.target.value));

    Get_Addressbook_list_Api(this.props.dispatch, {
      customerId: this.props.customerId || this.props.BusinessId,
      page: 1,
      perpage: 20,
      searchRegex: e.target.value,
    });

    // Api_Get_Addressbook_list_AGW(
    //   this.props.dispatch,
    //   { page: 0, perpage: 20, searchRegex: e.target.value },
    //   (call) => {}
    // );
  };

  handleContainerOnBottom = () => {
    this.loadMore();
  };

  render() {
    return (
      <React.Fragment>
        {this.props.ShowComponentMenu ? (
          <div
            className="AddressbookContainerPickup"
            onClick={() => this.openAddressbook()}
          >
            <img src={newAddressbook} />
            <span>
              {" "}
              <Trans i18nKey={"Addressbook"}> </Trans>{" "}
            </span>
          </div>
        ) : null}
        <Slide
          direction={"down"}
          in={this.props.openAddressBook}
          mountOnEnter
          unmountOnExit
        >
          <div className={styles.AddressbookNewOrderConatiner} style={{ zIndex: "9" ,direction:"ltr",marginInlineEnd:"-330px"}}>


            <div className={styles.largeHeader}>
              <Button icon={CLOSE} size="Medium" type="Secondary" onClick={this.closeAddressbook} />
              <div className={styles.largeHeaderTitles}>
                <Typography text={this.props.t(this.props.sourceOfAddressBookInNewOrder
                  ? this.props.sourceOfAddressBookInNewOrder.i18
                  : "Addressbook")} weight="Body_Middle_Bold" className={styles.SmallTitle} style={{ margin: "0", padding: "0" }} />
              </div>
            </div>


            {/* {(this.props.list.length > 0 ||
              this.props.searchRegex.length > 0) && (
                <div className={`NewOrderAddressbookSearchbarContainer`}>
                  <img src={searchicon} />
                  <input
                    value={this.props.searchRegex}
                    placeholder={this.props.t("AddressbookSearchbar")}
                    onChange={this.AddressbookSearchbar}
                  />
                </div>
              )} */}


            {(this.props.list.length > 0 ||
              this.props.searchRegex.length > 0) && (
                <div className={styles.NewOrderAddressbookSearchbarContainer}>
                  <Input type={"text"} iconStart={newsearch} placeHolder={this.props.t("Search")} value={this.props.searchRegex} onChange={this.AddressbookSearchbar} />
                </div>
              )}

            {/* {this.props.listLoading && (
              <CircularProgress className="AddressbookCircularProgress" />
            )} */}
            <BottomScrollListener onBottom={this.handleContainerOnBottom}>
              {(scrollRef) => (
                <div
                  ref={scrollRef}
                  id="AddressBookListOrder"
                  className={styles.AddressbookMenuListContainer}
                  style={{ display: this.props.list.length == 0 ? "none" : "" }}
                >
                  {this.props.list.map((item) => {
                    return (
                      <AddressItem
                        onEdit={this.handleEditAddress}
                        AddressData={item}
                      />
                    );
                  })}
                </div>
              )}
            </BottomScrollListener>
            {this.props.list.length == 0 && !this.props.listLoading && (
              <div
                className="nosavedaddressContainer"
                style={{ marginTop: "300px" }}
              >
                <img src={newAddressbook} />
                <p className="nosavedtitle">
                  {" "}
                  <Trans i18nKey={"Nosavedaddress"}> </Trans>{" "}
                </p>
                <p className="NosavedaddressDesc">
                  {" "}
                  <Trans i18nKey={"NosavedaddressDesc"}> </Trans>{" "}
                </p>
              </div>
            )}
          </div>
        </Slide>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  customerId: state.ViewTravel.pureData?.customerId,
  BusinessId: state.NewOrder.newOrder.customer.BusinessId,

  openAddressBook: state.Addressbook.openAddressBookInNewOrder,
  sourceOfAddressBookInNewOrder:
    state.Addressbook.sourceOfAddressBookInNewOrder,
  list: state.Addressbook.list,
  listLoading: state.Addressbook.listLoading,
  listError: state.Addressbook.listError,
  perpage: state.Addressbook.perpage,
  page: state.Addressbook.page,
  searchRegex: state.Addressbook.searchRegex,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(AddressbookEditOrder));
